export const GLOBAL_NAMESPACE = "";
export const SELF = "self";
export const STATIC = "static";
